"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHtmlAttr = exports.formatHtml = exports.decodeChatbotTextData = exports.debounce = exports.checkHaveTable = exports.RedirectionSecondaryOutlinedButtonUIOptimisationStyle = exports.RedirectionPrimaryOutlinedButtonUIOptimisationStyle = exports.RedirectionPrimaryButtonUIOptimisationStyle = void 0;
exports.processAccordionBlock = processAccordionBlock;
exports.processTableListBlock = processTableListBlock;
exports.transformToDateFnsFormat = exports.throttle = exports.replaceParams = exports.redirectionButtonUIOptimisation = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _htmlparser = require("htmlparser2");
var _domutils = require("domutils");
var _domhandler = require("domhandler");
var _constants = require("./constants");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var throttle = function throttle(func, delay) {
  var needRemain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var timer = null;
  var startTime = Date.now();
  return function () {
    var curTime = Date.now();
    var remaining = delay - (curTime - startTime);
    var context = this;
    clearTimeout(timer);
    if (remaining <= 0) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      func.apply(context, args);
      startTime = Date.now();
    } else if (needRemain) {
      timer = setTimeout(func, remaining);
    }
  };
};
exports.throttle = throttle;
var debounce = function debounce(fn, wait) {
  var timeout = null;
  return function () {
    if (timeout !== null) {
      clearTimeout(timeout);
    }
    timeout = window.setTimeout(fn, wait);
  };
};
exports.debounce = debounce;
var transformToDateFnsFormat = function transformToDateFnsFormat(dateText) {
  if (!dateText) {
    return '';
  }
  var formatText = dateText.replaceAll('D', 'd');
  if (!formatText.includes('HH') && formatText.includes('H')) {
    formatText = formatText.replace('H', 'h') + ' bbb';
  }
  return formatText;
};
exports.transformToDateFnsFormat = transformToDateFnsFormat;
var decodeChatbotTextData = function decodeChatbotTextData(data) {
  try {
    return JSON.parse(decodeURIComponent(data || ''));
  } catch (_unused) {
    return {};
  }
};
exports.decodeChatbotTextData = decodeChatbotTextData;
var replaceParams = function replaceParams(text, extraData) {
  var reg = new RegExp(/\$\{(.+?)\}/g);
  var origin = [];
  var lastIndex = reg.lastIndex;
  var result;
  while ((result = reg.exec(text)) != null) {
    origin.push(text.slice(lastIndex, result.index), extraData[result[1]]);
    lastIndex = reg.lastIndex;
  }
  origin.push(text.slice(lastIndex));
  return origin.every(function (ele) {
    return typeof ele === 'string' || typeof ele === 'number';
  }) ? origin.join('') : origin;
}; // 获取 string html 的属性 tagName 不传 默认是 所有元素

exports.replaceParams = replaceParams;
var getHtmlAttr = function getHtmlAttr(content, attrName) {
  var _content$match;
  var tagName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  var getRegExp = new RegExp("<".concat(tagName, "(?:[^'\">]*(?:\"[^\"]*\"|'[^']*')(?<! ").concat(attrName, "=))*[^'\">]* ").concat(attrName, "=(?:'([^']+)'|\"([^\"]+)\"|([^'\" <>]+)).*(?:>[^<>]*</").concat(tagName, "|/)>"));
  return (_content$match = content.match(getRegExp)) === null || _content$match === void 0 ? void 0 : _content$match.slice(1, 4).filter(Boolean)[0];
};
/**
 * @description 转换html样式
 */

exports.getHtmlAttr = getHtmlAttr;
var SECINDARY_COLORS = ['rgb(136, 136, 136)', 'rgb(68, 68, 68)'];
var TERIARY_COLORS = ['rgb(187, 187, 187)'];
var SHOPEE_COLORS = ['rgb(230, 0, 0)', 'rgb(255, 153, 0)', 'rgb(255, 255, 0)', 'rgb(250, 204, 204)', 'rgb(255, 235, 204)', 'rgb(255, 255, 204)', 'rgb(240, 102, 102)', 'rgb(255, 194, 102)', 'rgb(255, 255, 102)', 'rgb(238, 77, 45)'];
var COLOR_WHITELIST = ['rgb(234, 95, 0)']; // bank orange

var handleColorReplace = function handleColorReplace(text) {
  var color = text.split('color:')[1];
  if (SECINDARY_COLORS.includes(color)) {
    return 'color:rgba(0, 0, 0, 0.65)';
  } else if (TERIARY_COLORS.includes(color)) {
    return 'color:rgba(0, 0, 0, 0.54)';
  } else if (SHOPEE_COLORS.includes(color)) {
    return 'color:rgba(238, 77, 45, 1)';
  } else if (COLOR_WHITELIST.includes(color)) {
    return text;
  } else {
    return 'color:rgba(0, 0, 0, 0.87)';
  }
};
var formatHtml = function formatHtml(text) {
  var textColorRegex = /color:rgb?\(([^\)]*)\)/g;
  var noFillColorRegex = /background-color:rgba?\(([^\)]*)\)/g;
  var noFontSizeRegex = /font-size:\s*([^;"\s][^;"\n]*)/g;
  var noFontWeightRegex = /font-weight:\s*([a-zA-Z0-9]+)\b/g;
  var noTextDecorationRegex = /text-decoration:\s*([a-zA-Z]+)\b/g;
  var noSFLinkRegex = /content\.force\.com/g;
  var result = text.replace(textColorRegex, handleColorReplace).replace(noFillColorRegex, 'background-color:transparent').replace(noFontSizeRegex, '').replace(noFontWeightRegex, '').replace(noTextDecorationRegex, '').replace(noSFLinkRegex, '');
  return result;
};
exports.formatHtml = formatHtml;
function processAccordionBlock(content, accordionOptions) {
  var hasAccordion = content.includes('<accordion-block');
  if (!hasAccordion) {
    return content;
  }
  var _ref = accordionOptions || {},
    isUIOptimisationAccordion = _ref.isUIOptimisationAccordion,
    expand = _ref.expand,
    accordionIndex = _ref.accordionIndex,
    accordionItemIndex = _ref.accordionItemIndex,
    isUIOptimisationButton = _ref.isUIOptimisationButton;
  var dom = (0, _htmlparser.parseDocument)(content);
  var accordionBlocks = (0, _domutils.getElementsByTagName)('accordion-block', dom);
  accordionBlocks.forEach(function (accordionBlock, index) {
    var _accordionBlock$attri;
    var childrenNodes = (0, _domutils.getChildren)(accordionBlock);
    childrenNodes.forEach(function (childNode) {
      (0, _domutils.removeElement)(childNode);
    });
    var newAccordion = new _domhandler.Element('accordion-block', _objectSpread(_objectSpread({}, accordionBlock.attribs), {}, {
      style: (0, _domutils.hasAttrib)(accordionBlock, 'style') ? accordionBlock.attribs.style.replace(/width:[^;]+;/, 'width:100%;') : '',
      'is-ui-optimisation-accordion': isUIOptimisationAccordion ? 'true' : 'false',
      'is-ui-optimisation-button': isUIOptimisationButton ? 'true' : 'false',
      expand: isUIOptimisationAccordion ? expand ? 'true' : 'false' : ((_accordionBlock$attri = accordionBlock.attribs) === null || _accordionBlock$attri === void 0 ? void 0 : _accordionBlock$attri.expand) || 'true',
      'default-select-index': index === accordionIndex ? (accordionItemIndex === null || accordionItemIndex === void 0 ? void 0 : accordionItemIndex.toString()) || '' : '',
      index: index.toString()
    }), accordionBlock.childNodes);
    (0, _domutils.replaceElement)(accordionBlock, newAccordion);
  });
  return (0, _domutils.getInnerHTML)(dom);
}
function processTableListBlock(content, options) {
  var hasTableList = content.includes('<table-list');
  if (!hasTableList) {
    return content;
  }
  var isUIOptimisationButton = options.isUIOptimisationButton;
  var dom = (0, _htmlparser.parseDocument)(content);
  var tableListBlocks = (0, _domutils.getElementsByTagName)('table-list', dom);
  tableListBlocks.forEach(function (tableListBlock) {
    var childrenNodes = (0, _domutils.getChildren)(tableListBlock);
    childrenNodes.forEach(function (childNode) {
      (0, _domutils.removeElement)(childNode);
    });
    var newTableListBlock = new _domhandler.Element('table-list', _objectSpread(_objectSpread({}, tableListBlock.attribs), {}, {
      'is-ui-optimisation-button': isUIOptimisationButton ? 'true' : 'false'
    }), tableListBlock.childNodes);
    (0, _domutils.replaceElement)(tableListBlock, newTableListBlock);
  });
  return (0, _domutils.getInnerHTML)(dom);
}
var RedirectionPrimaryButtonUIOptimisationStyle = 'display: block;background-color: #EE4D2D;text-align: center;line-height: 16px;font-size: 14px !important;color:white;padding: 10px 16px;border-radius: 2px;font-weight: 400;box-sizing: border-box;';
exports.RedirectionPrimaryButtonUIOptimisationStyle = RedirectionPrimaryButtonUIOptimisationStyle;
var RedirectionPrimaryOutlinedButtonUIOptimisationStyle = 'display: block;background-color: #FFFFFF;text-align: center;line-height: 16px;font-size: 14px !important;color:#EE4D2D !important;padding: 10px 16px;border-radius: 2px;font-weight: 400;box-sizing: border-box;border: 1px solid #EE4D2D;';
exports.RedirectionPrimaryOutlinedButtonUIOptimisationStyle = RedirectionPrimaryOutlinedButtonUIOptimisationStyle;
var RedirectionSecondaryOutlinedButtonUIOptimisationStyle = 'display: block;background-color: #FFFFFF;text-align: center;line-height: 16px;font-size: 14px !important;color:rgba(0, 0, 0, 0.87) !important;padding: 10px 16px;border-radius: 2px;font-weight: 400;box-sizing: border-box;border: 1px solid rgba(0, 0, 0, 0.26);';
exports.RedirectionSecondaryOutlinedButtonUIOptimisationStyle = RedirectionSecondaryOutlinedButtonUIOptimisationStyle;
var redirectionButtonUIOptimisation = function redirectionButtonUIOptimisation(content) {
  var dom = (0, _htmlparser.parseDocument)(content); // 故意写成这样的不然 style 里面会有空格

  var divs = (0, _domutils.getElementsByTagName)('div', dom);
  var redirectionButtons = divs.filter(function (div) {
    var _div$attribs, _div$attribs$class, _div$attribs$class$in;
    return div === null || div === void 0 ? void 0 : (_div$attribs = div.attribs) === null || _div$attribs === void 0 ? void 0 : (_div$attribs$class = _div$attribs.class) === null || _div$attribs$class === void 0 ? void 0 : (_div$attribs$class$in = _div$attribs$class.includes) === null || _div$attribs$class$in === void 0 ? void 0 : _div$attribs$class$in.call(_div$attribs$class, 'redirection-button-to-taskbots-or-app-page');
  });
  redirectionButtons.forEach(function (block) {
    var _buttonData;
    var buttonData;
    try {
      buttonData = JSON.parse(block.attribs['data-button-json'] || '');
    } catch (error) {
      console.error('JSON.parse data-button-json');
    }
    switch ((_buttonData = buttonData) === null || _buttonData === void 0 ? void 0 : _buttonData.buttonStyle) {
      case _constants.ButtonStyle.PrimaryButton:
        block.attribs.style = RedirectionPrimaryButtonUIOptimisationStyle;
        break;
      case _constants.ButtonStyle.PrimaryButtonOutlined:
        block.attribs.style = RedirectionPrimaryOutlinedButtonUIOptimisationStyle;
        break;
      case _constants.ButtonStyle.SecondaryButtonOutlined:
        block.attribs.style = RedirectionSecondaryOutlinedButtonUIOptimisationStyle;
        break;
      default:
        block.attribs.style = RedirectionPrimaryButtonUIOptimisationStyle;
        break;
    }
    block.attribs.class = "".concat(block.attribs.class, " ui-optimisation-button");
  }); // 这个里是 处理 a 标签也有一种 button 的样式

  var as = (0, _domutils.getElementsByTagName)('a', dom);
  var linkButtons = as.filter(function (a) {
    var _a$attribs, _a$attribs$class, _a$attribs$class$incl;
    return a === null || a === void 0 ? void 0 : (_a$attribs = a.attribs) === null || _a$attribs === void 0 ? void 0 : (_a$attribs$class = _a$attribs.class) === null || _a$attribs$class === void 0 ? void 0 : (_a$attribs$class$incl = _a$attribs$class.includes) === null || _a$attribs$class$incl === void 0 ? void 0 : _a$attribs$class$incl.call(_a$attribs$class, 'chatbot-text-link-tel_button-style');
  });
  linkButtons.forEach(function (block) {
    var buttonStyle;
    try {
      var _block$attribs, _block$attribs$href, _block$attribs$href$m;
      var match = block === null || block === void 0 ? void 0 : (_block$attribs = block.attribs) === null || _block$attribs === void 0 ? void 0 : (_block$attribs$href = _block$attribs.href) === null || _block$attribs$href === void 0 ? void 0 : (_block$attribs$href$m = _block$attribs$href.match) === null || _block$attribs$href$m === void 0 ? void 0 : _block$attribs$href$m.call(_block$attribs$href, /button_style=([^&]+)/);
      buttonStyle = match ? +match[1] : null;
    } catch (error) {
      console.error('get link href error', error);
    }
    switch (buttonStyle) {
      case _constants.ButtonStyle.PrimaryButton:
        block.attribs.style = RedirectionPrimaryButtonUIOptimisationStyle;
        break;
      case _constants.ButtonStyle.PrimaryButtonOutlined:
        block.attribs.style = RedirectionPrimaryOutlinedButtonUIOptimisationStyle;
        break;
      case _constants.ButtonStyle.SecondaryButtonOutlined:
        block.attribs.style = RedirectionSecondaryOutlinedButtonUIOptimisationStyle;
        break;
      default:
        block.attribs.style = RedirectionPrimaryButtonUIOptimisationStyle;
        break;
    }
  });
  return (0, _domutils.getInnerHTML)(dom);
};
exports.redirectionButtonUIOptimisation = redirectionButtonUIOptimisation;
var checkHaveTable = function checkHaveTable(content) {
  var dom = (0, _htmlparser.parseDocument)(content);
  var divs = (0, _domutils.getElementsByTagName)('div', dom);
  var tables = (0, _domutils.getElementsByTagName)('table', dom);
  return divs.some(function (div) {
    var _div$attribs2, _div$attribs2$class, _div$attribs2$class$i;
    return div === null || div === void 0 ? void 0 : (_div$attribs2 = div.attribs) === null || _div$attribs2 === void 0 ? void 0 : (_div$attribs2$class = _div$attribs2.class) === null || _div$attribs2$class === void 0 ? void 0 : (_div$attribs2$class$i = _div$attribs2$class.includes) === null || _div$attribs2$class$i === void 0 ? void 0 : _div$attribs2$class$i.call(_div$attribs2$class, 'quill-better-table-wrapper');
  }) && !!(tables !== null && tables !== void 0 && tables.length);
};
exports.checkHaveTable = checkHaveTable;